import { render, staticRenderFns } from "./comp_ProductPage-LimitedTimeOffer.vue?vue&type=template&id=5c98d9aa&scoped=true&"
import script from "./comp_ProductPage-LimitedTimeOffer.vue?vue&type=script&lang=js&"
export * from "./comp_ProductPage-LimitedTimeOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98d9aa",
  null
  
)

export default component.exports